// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3DJ7d","content":"styles_content__3B8N3","selectAll":"styles_selectAll__37R15"};